// export const urlcode = 'http://192.168.100.43:1024/sj'//yyl
// export const urlcode = 'http://192.168.100.50:1024/sj'//测试
export const urlcode = 'https://api.sjhlwyy.com/sj'//正式
// export const urlcode = 'http://192.168.100.41:1024/sj'//fqf

export const timcofig = {
  SDKAPPID: 1400793445,
  userSig: "",
}

export default {timcofig, urlcode}



// WEBPACK FOOTER //
// ./src/config.js